import { render, staticRenderFns } from "./BonusImport.vue?vue&type=template&id=4eadf977&"
import script from "./BonusImport.vue?vue&type=script&lang=js&"
export * from "./BonusImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports